/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerOrderItemSummary } from './CustomerOrderItemSummary';
import {
    CustomerOrderItemSummaryFromJSON,
    CustomerOrderItemSummaryFromJSONTyped,
    CustomerOrderItemSummaryToJSON,
    CustomerOrderItemSummaryToJSONTyped,
} from './CustomerOrderItemSummary';

/**
 * 
 * @export
 * @interface PagedResultCustomerOrderItemSummary
 */
export interface PagedResultCustomerOrderItemSummary {
    /**
     * 
     * @type {Array<CustomerOrderItemSummary>}
     * @memberof PagedResultCustomerOrderItemSummary
     */
    content: Array<CustomerOrderItemSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedResultCustomerOrderItemSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedResultCustomerOrderItemSummary
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PagedResultCustomerOrderItemSummary interface.
 */
export function instanceOfPagedResultCustomerOrderItemSummary(value: object): value is PagedResultCustomerOrderItemSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedResultCustomerOrderItemSummaryFromJSON(json: any): PagedResultCustomerOrderItemSummary {
    return PagedResultCustomerOrderItemSummaryFromJSONTyped(json, false);
}

export function PagedResultCustomerOrderItemSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedResultCustomerOrderItemSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(CustomerOrderItemSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
    };
}

export function PagedResultCustomerOrderItemSummaryToJSON(json: any): PagedResultCustomerOrderItemSummary {
    return PagedResultCustomerOrderItemSummaryToJSONTyped(json, false);
}

export function PagedResultCustomerOrderItemSummaryToJSONTyped(value?: PagedResultCustomerOrderItemSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(CustomerOrderItemSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

